import { Grade12CourseOverviewData } from "../../data/OSSDOverviewData/Grade12CourseOverviewData";
import Grade from "../../components/CourseComp/Grade";

export default function GradeTwelveOverviewPage() {
    return (
        <div>
            <Grade data={Grade12CourseOverviewData} />
        </div>
    )
}